<h1 class="accent-background-element">Export CSV</h1>

<mat-dialog-content>
  @if ((loaded | async) ===true) {
    <form [formGroup]="form">
      <div class="column">
        <h4>Country</h4>
        <div>
          <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
            <mat-select formControlName="country" class='accent-border-element  mat-body' placeholder="Country">
              @for (country of CountriesIDs | keyvalue; track country) {
                <mat-option   class='accent-hover-element' [value]='country.value'>{{country.value}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <br>
        <div class="inner-row">
          <h4>Type 1*:</h4>
          <div>
            <mat-radio-group formControlName="type1">
              <mat-radio-button [value]="ShopTypesEnum.clinic"> Clinic</mat-radio-button>
              <mat-radio-button [value]="ShopTypesEnum.entOffice"> ENT Office </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </form>
    }

    @if ((loaded | async) ===false) {
      <div class="spinner-container">
        <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
      </div>
    }

  </mat-dialog-content>

  @if ((loaded | async) ===true) {
    <mat-dialog-actions>
      <div class="spacer"></div>
      <button mat-raised-button color="accent" (click)="onSubmit()" [disabled]="isDisabledButton()">Export</button>
    </mat-dialog-actions>
  }